import inclined1 from './images/CircularMotionScreen_SJSA_1D_BW.png';
import inclined2 from './images/CircularMotionScreen_SJSA_2D_BW.png';
import inclined3 from './images/CircularMotionScreen_SJSA_3D_BW.png';
import inclined4 from './images/CircularMotionScreen_SJSA_4D_BW.png';
import inclined1_2 from './images/CircularMotionScreen_SJSA_1D_BW_2.png';
import inclined2_2 from './images/CircularMotionScreen_SJSA_2D_BW_2.png';
import inclined3_2 from './images/CircularMotionScreen_SJSA_3D_BW_2.png';
import inclined4_2 from './images/CircularMotionScreen_SJSA_4D_BW_2.png';

import grizzly1 from './images/GrizzlyScreen_SG_1D_BW.png';
import grizzly2 from './images/GrizzlyScreen_SG_2D_BW.png';
import grizzly1_2 from './images/GrizzlyScreen_SG_1D_BW_2.png';
import grizzly2_2 from './images/GrizzlyScreen_SG_2D_BW_2.png';

import horizontal1 from './images/LinearMotionScreen_SL_1D_BW.png';
import horizontal2 from './images/LinearMotionScreen_SL_2D_BW.png';
import horizontal3 from './images/LinearMotionScreen_SL_3D_BW.png';
import horizontal1_2 from './images/LinearMotionScreen_SL_1D_BW_2.png';
import horizontal2_2 from './images/LinearMotionScreen_SL_2D_BW_2.png';
import horizontal3_2 from './images/LinearMotionScreen_SL_3D_BW_2.png';

import scalping2 from './images/FreeFallScreen_SS_2D_BW.png';
import scalping3 from './images/FreeFallScreen_SS_3D_BW.png';
import scalping2_2 from './images/FreeFallScreen_SS_2D_BW_2.png';
import scalping3_2 from './images/FreeFallScreen_SS_3D_BW_2.png';

import multi1 from './images/BananaScreen_1D_BW.png';
import multi2 from './images/BananaScreen_2D_BW.png';

import { GenericScreenTypes } from './GenericScreenTypes';
import type { UnitInfoGenericScreenInterface } from '../../../store/units/types';
const images = new Map<string, string>();

images.set(`${GenericScreenTypes.INCLINED_SCREEN}${1}${1}`, inclined1);
images.set(`${GenericScreenTypes.INCLINED_SCREEN}${2}${1}`, inclined2);
images.set(`${GenericScreenTypes.INCLINED_SCREEN}${3}${1}`, inclined3);
images.set(`${GenericScreenTypes.INCLINED_SCREEN}${4}${1}`, inclined4);
images.set(`${GenericScreenTypes.INCLINED_SCREEN}${1}${2}`, inclined1_2);
images.set(`${GenericScreenTypes.INCLINED_SCREEN}${2}${2}`, inclined2_2);
images.set(`${GenericScreenTypes.INCLINED_SCREEN}${3}${2}`, inclined3_2);
images.set(`${GenericScreenTypes.INCLINED_SCREEN}${4}${2}`, inclined4_2);

images.set(`${GenericScreenTypes.GRIZZLY_SCREEN}${1}${1}`, grizzly1);
images.set(`${GenericScreenTypes.GRIZZLY_SCREEN}${2}${1}`, grizzly2);
images.set(`${GenericScreenTypes.GRIZZLY_SCREEN}${1}${2}`, grizzly1_2);
images.set(`${GenericScreenTypes.GRIZZLY_SCREEN}${2}${2}`, grizzly2_2);

images.set(`${GenericScreenTypes.HORIZONTAL_SCREEN}${1}${1}`, horizontal1);
images.set(`${GenericScreenTypes.HORIZONTAL_SCREEN}${2}${1}`, horizontal2);
images.set(`${GenericScreenTypes.HORIZONTAL_SCREEN}${3}${1}`, horizontal3);
images.set(`${GenericScreenTypes.HORIZONTAL_SCREEN}${1}${2}`, horizontal1_2);
images.set(`${GenericScreenTypes.HORIZONTAL_SCREEN}${2}${2}`, horizontal2_2);
images.set(`${GenericScreenTypes.HORIZONTAL_SCREEN}${3}${2}`, horizontal3_2);

images.set(`${GenericScreenTypes.MULTISLOPE_SCREEN}${1}${1}`, multi1);
images.set(`${GenericScreenTypes.MULTISLOPE_SCREEN}${2}${1}`, multi2);
images.set(`${GenericScreenTypes.MULTISLOPE_SCREEN}${1}${2}`, multi1);
images.set(`${GenericScreenTypes.MULTISLOPE_SCREEN}${2}${2}`, multi2);

images.set(`${GenericScreenTypes.SCALPING_SCREEN}${2}${1}`, scalping2);
images.set(`${GenericScreenTypes.SCALPING_SCREEN}${3}${1}`, scalping3);
images.set(`${GenericScreenTypes.SCALPING_SCREEN}${2}${2}`, scalping2_2);
images.set(`${GenericScreenTypes.SCALPING_SCREEN}${3}${2}`, scalping3_2);

export const getImageGenericScreen = ({
  modelName,
  nbrOfDecks,
  ..._rest
}: Pick<
  UnitInfoGenericScreenInterface,
  'modelName' | 'nbrOfDecks'
>): string => {
  if (modelName === undefined || nbrOfDecks === undefined) {
    return '';
  }
  return images.get(`${modelName}${nbrOfDecks}${1}`) ?? '';
};

export const getImageGenericScreen2 = ({
  modelName,
  nbrOfDecks,
}: Pick<
  UnitInfoGenericScreenInterface,
  'modelName' | 'nbrOfDecks'
>): string => {
  if (modelName === undefined || nbrOfDecks === undefined) {
    return '';
  }
  return images.get(`${modelName}${nbrOfDecks}${2}`) ?? '';
};
